import type { ReactNode } from 'react'
import type { TFunction } from 'i18next'
import { useReducer } from 'react'

import {
  OpenedTooltipStateProvider,
  dropdownCategoryReducer,
  errorReducer,
  linkTooltipReducer,
} from './LinkTooltipContext'
import { dropdownCategoryInitialState, errorInitialState, initialState } from './LinkTooltip.constants'
import { useTranslate } from '../../../../../../utils/translate'

export default function SettingsLayerTooltipStateProvider({ children }: Readonly<{ children: ReactNode }>) {
  const [linkTooltipState, linkTooltipDispatch] = useReducer(linkTooltipReducer, initialState)
  const [categoryState, categoryDispatch] = useReducer(dropdownCategoryReducer, dropdownCategoryInitialState)
  const [errorState, errorDispatch] = useReducer(errorReducer, errorInitialState)
  const t = useTranslate('shop') as TFunction

  return (
    <OpenedTooltipStateProvider
      {...{
        t,
        linkTooltipState,
        linkTooltipDispatch,
        categoryState,
        categoryDispatch,
        errorState,
        errorDispatch,
      }}
    >
      {children}
    </OpenedTooltipStateProvider>
  )
}
